import { useEffect, useState } from 'react';

/** True while a question's pre-stimulus blank shows; keyed on the visit so a revisit blanks again. */
export function usePreBlank(visitKey: string, blankMs: number | undefined): boolean {
  const [doneKey, setDoneKey] = useState<string | null>(null);
  const active = !!visitKey && !!blankMs && blankMs > 0 && doneKey !== visitKey;

  useEffect(() => {
    if (!visitKey || !blankMs || blankMs <= 0) return;
    const t = setTimeout(() => setDoneKey(visitKey), blankMs);
    return () => clearTimeout(t);
  }, [visitKey, blankMs]);

  return active;
}
